<div class="buttons_container">
    <div class="btn-group" role="group">
<!--         <button (click)="onOpenCreateTaskModal(createTaskView)" *ngIf="isShowTaskButton" style="margin-right: 12px;"
                [disabled]="dashes && !dashes.length"
                class="button-icon size-m primary-button"  data-action="openCreateTaskModal">
            <span>{{ 'TASKS.BUTTONS.CREATE_TASK' | translate }}</span>
        </button> -->
        <button (click)="onOpenCreateTaskForm()" *ngIf="isShowTaskButton"
                [disabled]="!alias && (dashes === undefined  || !dashes.length)"
                class="button-icon size-m primary-button"  data-action="openCreateTaskModal">
            <span>{{ 'TASKS.BUTTONS.CREATE_TASK' | translate }}</span>
        </button>
        <button (click)="openDialog(createGroupView,500)" *ngIf="isShowBoardButton" class="button-icon size-m secondary-button" 
                style="margin-left: 10px;">
            <span>{{ 'TASKS.BUTTONS.CREATE_GROUP' | translate }}</span>
        </button>
<!--         <button (click)="onOpenModal(createDashView)" *ngIf="isShowBoardButton" class="button-icon size-m secondary-button" 
                style="margin-left: 10px;">
            <span>{{ 'TASKS.BUTTONS.CREATE_BOARD' | translate }}</span>
        </button> -->
        <button (click)="onOpenCreateDashForm()" *ngIf="isShowBoardButton" class="button-icon size-m secondary-button" 
                style="margin-left: 10px;">
            <span>{{ 'TASKS.BUTTONS.CREATE_BOARD' | translate }}</span>
        </button>
        <h2 *ngIf="alias && selectedDash" style="margin-left: 15px;">{{ selectedDash.name }}</h2>
    </div>

    <div *ngIf="isShowRightButtons && board !== 'all' || alias" class="btn-group rightButtons ms-auto" role="group">
        <button (click)="openBoardLife()" *ngIf="alias && selectedDash" [class.active]="viewType === 'logs'"
                class="btn btn-light" ngbTooltip="{{'TASKS.TOOLTIPS.HISTORY' | translate}}">
            <i class="bi bi-clock-history"></i>
        </button>
        <button (click)="emitChangeDesk.emit('table')" *ngIf="alias" [class.active]="viewType === 'table'"
                class="btn btn-light" ngbTooltip="{{'TASKS.TOOLTIPS.TABLE' | translate}}">
            <i class="bi bi-list-task"></i>
        </button>
        <button (click)="emitChangeDesk.emit('column')" *ngIf="alias" [class.active]="viewType === 'column'"
                class="btn btn-light" ngbTooltip="{{'TASKS.TOOLTIPS.COLUMN' | translate}}">
            <i class="bi bi-layout-three-columns"></i>
        </button>
        <button (click)="calendar.click()" class="btn btn-light"
                ngbTooltip="{{'TASKS.TOOLTIPS.CALENDAR_SORT' | translate}}">
            <i class="bi bi-calendar-date"></i>
        </button>
        <app-component-date-time-picker #calendar
                                        (pickedDate)="emitAddRange.emit($event)"
                                        [hiddenCalendar]="true"
                                        [inline]="false"
                                        [isRange]="true"
                                        [showTime]="false"
                                        [stringify]="false">
        </app-component-date-time-picker>

        <i (click)="onOpenModal(settingsView)"
           class="bi bi-sliders settings"
           ngbTooltip="{{'TASKS.TOOLTIPS.SETTINGS' | translate}}"
        ></i>

        <i (click)="router.navigate(['account', 'tasks', 'options', 'statuses'], {queryParams: {alias: selectedDash.alias}})"
           *ngIf="alias && selectedDash && isShowSettingBoardGear"
           class="bi bi-gear-fill settings"
           data-action='openSettings'
           ngbTooltip="{{'TASKS.TOOLTIPS.BOARD_SETTINGS' | translate}}"
        ></i>
    </div>
</div>

<ng-template #createTaskView let-modal>
    <app-button-modal-close (closeEmit)="closeTaskModal()" [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h1>{{ 'MODALS.HEADERS.TASK' | translate }}</h1>
        <h2>{{ 'MODALS.FIELDS.TITLE' | translate }}</h2>
        <input #taskName aria-describedby="emailHelp" class="form-control" id="taskName" required>

        <h2 class="mt-2">{{ 'MODALS.FIELDS.DESCRIPTION' | translate }}</h2>
        <div class="task__content mb-3">
            <app-component-ckeditor
                    (emitFinish)="description = $event[1]"
                    [isShowButtons]="false"
                    [isShowEditor]="false">
            </app-component-ckeditor>
        </div>

        <h2 *ngIf="!alias">{{ 'MODALS.FIELDS.BUSINESS_PROCESS' | translate }}</h2>
        <select (change)="selectBoard(selectedDash)" *ngIf="!alias" [(ngModel)]="selectedDash" class="form-select">
            <option [ngValue]="null" hidden>{{ 'MODALS.FIELDS.SELECT.BUSINESS_PROCESS' | translate }}</option>
            <option *ngFor="let item of dashes" [ngValue]="item"> [{{ item.alias }}] {{ item.name }}</option>
        </select>

        <div *ngIf="changeBoard" class="dropdown">
            <h2>{{ 'MODALS.FIELDS.TASK_TYPE' | translate }}</h2>
            <button aria-expanded="false" class="btn btn-block dropdown-toggle" data-bs-toggle="dropdown" type="button">
                <i [class]="selectedType.icon"></i> {{ selectedType.name ? selectedType.name : 'MODALS.SELECT.NOT_SELECTED' | translate }}
            </button>
            <ul class="dropdown-menu" style="overflow: auto; max-height: 350px; width: 100%">
                <li (click)="selectedType = item" *ngFor="let item of changeBoard.task_types">
                    <a class="dropdown-item">
                        <i [class]="item.icon"></i> {{ item.name }}
                    </a>
                </li>
            </ul>
        </div>

        <button (click)="onCreateTask(modal, taskName.value);" [disabled]="isLockButton"
                class="btn btn-success mt-3"
                data-action="createTask">
            <span *ngIf="!isLockButton else refresh">{{ 'MODALS.BUTTONS.CREATE' | translate }}</span>
        </button>
    </div>
</ng-template>

<!-- <ng-template #createDashView let-modal>
    <div class="modal-body">
        <h1>{{ 'MODALS.HEADERS.BOARD' | translate }}</h1>

        <h2>{{ 'MODALS.FIELDS.ICON'|translate }} </h2>
        <i (click)="isShowIcons = !isShowIcons"
           *ngIf="!icons.selected"
           data-action="openIcons"
           style="cursor: pointer; width: 200px;"
        >
            {{ 'MODALS.FIELDS.SELECT.ICON_NOT_SELECTED' | translate }}
        </i>
        <i (click)="icons.selected = null"
           *ngIf="icons.selected"
           class="bi bi-trash"
           data-action="deleteIcon"
           style="color: red; cursor: pointer; margin-left: 50px; margin-bottom: -15px;"
        ></i>
        <i (click)="isShowIcons = !isShowIcons"
           *ngIf="icons.selected"
           class="{{icons.selected}}"
           data-action="openIcons"
           style="font-size: 3em; cursor: pointer; width: 50px; height: 50px; margin-bottom: 15px;"
        ></i>

        <div *ngIf="isShowIcons" class="iconsTable table2">
            <i (click)="icons.selected = icon; isShowIcons = false;"
               *ngFor="let icon of icons.all"
               [attr.data-icon]="icon"
               class="{{icon}}"
               data-action="setIcon"
               style="margin: 5px; cursor: pointer; font-size: 2em;"
            ></i>
        </div>

        <h2 class="mt-2">{{ 'MODALS.FIELDS.TITLE' | translate }}</h2>
        <input #dashName aria-describedby="emailHelp" class="form-control" required style="margin-bottom: 10px;">

        <h2 class="mt-2">{{ 'MODALS.FIELDS.ALIAS' | translate }}</h2>
        <input #dashAlias [value]="helper.generateDashboardAlias(dashName.value)" aria-describedby="emailHelp"
               class="form-control" required>

        <div *ngIf="!selectedGroup">
            <h2 class="mt-2">{{ 'MODALS.FIELDS.GROUP' | translate }}</h2>
            <select #boardGroup (change)="selectedGroupId = boardGroup.value" class="form-select">
                <option hidden selected value="">{{ 'MODALS.FIELDS.SELECT.GROUP' | translate }}</option>
                <option *ngFor="let group of groups" [value]="group.id">{{ group.title }}</option>
            </select>
            <span *ngIf="selectedGroup">{{ selectedGroup.title }}</span>
        </div>

        <h2 class="mt-2">{{ 'MODALS.FIELDS.DESCRIPTION' | translate }}</h2>
        <input #dashComment aria-describedby="emailHelp" class="form-control">

        <div>
            <input #isNeedToCreateStatuses id="end" name="end" style="width: auto;" type="checkbox">
            <label for="end" style="margin-left: 5px;">{{ 'MODALS.FIELDS.BASE_STATUSES' | translate }}</label>
        </div>

        <button (click)="onCreateDash(dashName.value, dashAlias.value, dashComment.value, isNeedToCreateStatuses.checked, modal);"
                [disabled]="isLockButton"
                class="btn btn-success mt-2"
                data-action="createBoard">
            <span *ngIf="!isLockButton else refresh">{{ 'MODALS.BUTTONS.CREATE' | translate }}</span>
        </button>
    </div>
</ng-template> -->

<ng-template #createGroupView >
    <div class="wrap" style="display: flex; flex-direction: column; gap:20px">
        <div class="title"  >
            {{ 'MODALS.HEADERS.GROUP2' | translate }}
            <app-component-loading [size]="'inline'" [margin]="'0px'" *ngIf="isLockButton"></app-component-loading>
        </div>
        <input matInput class="fc-input body-l-regular text-extra"
            [formControl]="dashNameFC" autocomplete="disabled" [placeholder]=" 'MODALS.FIELDS.TITLE' | translate">
        <button (click)="onCreateGroup()"  data-action="onCreateGroup" 
                    [disabled]="dashNameFC.valid !==true || isLockButton"
                    class="button-icon size-xl primary-button" >
                {{('MODALS.BUTTONS.CREATE'|translate) }}
        </button>
    </div>
</ng-template>

<ng-template #settingsView let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <app-board-settings-modal
                (emitReloading)="emitSaveSettings.emit($event)"
                [board]="selectedDash"
        ></app-board-settings-modal>
    </div>
</ng-template>

<ng-template #taskView let-modal>
    <app-button-modal-close (closeEmit)="cleanHash()" [modal]="modal" modalSize="xl"></app-button-modal-close>
    <div class="modal-body">
        <app-component-task-detail (emitOnDelete)="$event ? modal.close() : null"
                                   *ngIf="taskAlias"
                                   [taskAlias]="taskAlias"
        ></app-component-task-detail>
    </div>
</ng-template>

<ng-template #refresh>
    <app-component-loading size="inline"></app-component-loading>
</ng-template>
